import type { WidgetOptions } from "./config";
import type { WidgetPayload } from "./types";

export async function fetchWidgetEvents(options: WidgetOptions): Promise<WidgetPayload> {
  const url = buildEventsUrl(options);
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Widget API returned " + response.status);
  }

  return (await response.json()) as WidgetPayload;
}

export function buildEventsUrl(options: WidgetOptions): string {
  const base = normalizeBaseUrl(options.apiBaseUrl);
  const url = new URL("widgets/events", base);
  url.searchParams.set("key", options.key);
  url.searchParams.set("view", options.view === "calendar" ? "calendar" : "list");
  if (options.limit) {
    url.searchParams.set("limit", String(options.limit));
  }
  return url.toString();
}

function normalizeBaseUrl(apiBaseUrl: string): string {
  if (!apiBaseUrl.trim()) {
    return window.location.origin;
  }
  return new URL(apiBaseUrl, window.location.origin).toString();
}
